/**
 * Secret Sale unlocked PLP: session headline, code/%, countdown, gender nav.
 * Reads SmilodoxSecretSaleSession only — does not own timer/unlock logic.
 */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
      return;
    }
    fn();
  }

  function SmilodoxSecretSalePlp(root) {
    this.root = root;
    this.headingEl = root.querySelector("[data-ssp-heading]");
    this.activationEl = root.querySelector("[data-ssp-activation]");
    this.activationPrefixEl = root.querySelector("[data-ssp-activation-prefix]");
    this.activationCodeEl = root.querySelector("[data-ssp-activation-code]");
    this.activationSuffixEl = root.querySelector("[data-ssp-activation-suffix]");
    this.countdownEl = root.querySelector("[data-ssp-countdown]");
    this.countdownMm = root.querySelector("[data-ssp-countdown-mm]");
    this.countdownSs = root.querySelector("[data-ssp-countdown-ss]");
    this.navEl = root.querySelector("[data-ssp-nav]");

    this.campaignKey = root.getAttribute("data-campaign-key") || "";
    this.collectionHandle = root.getAttribute("data-collection-handle") || "";
    this.headingTemplate =
      root.getAttribute("data-heading-template") || "DEIN EXKLUSIVER -__PERCENT__% RABATT AUF ALLES";
    this.headingFallback = root.getAttribute("data-heading-fallback") || "DEIN EXKLUSIVER SECRET SALE";
    this.activationTemplate =
      root.getAttribute("data-activation-template") ||
      "-__PERCENT__% Rabattcode: __CODE__ IST AKTIV";
    this.tickerId = null;
    this.destroyed = false;

    this.tick = this.tick.bind(this);
  }

  SmilodoxSecretSalePlp.prototype.api = function () {
    return window.SmilodoxSecretSaleSession || null;
  };

  /* Body attrs from first-paint script — state only; templates stay in this module. */
  SmilodoxSecretSalePlp.prototype.activeFromBody = function () {
    var body = document.body;
    if (!body || !body.classList.contains("smilodox-secret-sale-session-ready")) return null;
    var code = String(body.getAttribute("data-ss-code") || "").trim();
    var percent = parseInt(body.getAttribute("data-ss-percent") || "0", 10);
    var expiry = parseInt(body.getAttribute("data-ss-expires-at") || "0", 10);
    if (!code || !expiry || expiry <= Date.now()) return null;
    if (!Number.isFinite(percent) || percent < 1) percent = 0;
    return {
      code: code.toUpperCase(),
      percent: percent,
      remainingMs: Math.max(0, expiry - Date.now()),
    };
  };

  SmilodoxSecretSalePlp.prototype.render = function (active) {
    if (!active) {
      if (this.activationEl) this.activationEl.setAttribute("hidden", "");
      if (this.countdownEl) this.countdownEl.setAttribute("data-expired", "true");
      if (this.countdownMm) this.countdownMm.textContent = "00";
      if (this.countdownSs) this.countdownSs.textContent = "00";
      return;
    }

    var percent = active.percent || 0;
    var code = active.code || "";
    if (this.headingEl) {
      var heading = percent
        ? this.headingTemplate
            .replace(/__PERCENT__/g, String(percent))
            .replace(/\{percent\}/g, String(percent))
        : this.headingFallback;
      // Underline the discount token only (percent comes from validated session).
      var safeHeading = String(heading)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
      this.headingEl.innerHTML = safeHeading.replace(
        /(-?\d+%)/g,
        '<span class="ssp__pct-underline">$1</span>',
      );
    }
    if (this.activationEl && this.activationPrefixEl && this.activationCodeEl && this.activationSuffixEl) {
      // Split on __CODE__ so only the validated code is emphasized via <strong> textContent.
      var parts = String(this.activationTemplate || "").split("__CODE__");
      var prefix = (parts[0] || "")
        .replace(/__PERCENT__/g, String(percent))
        .replace(/\{percent\}/g, String(percent));
      var suffix = (parts[1] || "")
        .replace(/__PERCENT__/g, String(percent))
        .replace(/\{percent\}/g, String(percent));
      this.activationPrefixEl.textContent = prefix;
      this.activationCodeEl.textContent = code;
      this.activationSuffixEl.textContent = suffix;
      this.activationEl.removeAttribute("hidden");
    }
    this.updateClock(active.remainingMs);
  };

  SmilodoxSecretSalePlp.prototype.updateClock = function (remainingMs) {
    var api = this.api();
    var clock = api ? api.formatClock(remainingMs) : { mm: "00", ss: "00", totalSec: 0 };
    if (this.countdownMm) this.countdownMm.textContent = clock.mm;
    if (this.countdownSs) this.countdownSs.textContent = clock.ss;
    if (this.countdownEl) {
      if (clock.totalSec <= 0) this.countdownEl.setAttribute("data-expired", "true");
      else this.countdownEl.removeAttribute("data-expired");
    }
  };

  SmilodoxSecretSalePlp.prototype.tick = function () {
    if (this.destroyed) return;
    var api = this.api();
    var active = api && api.getActive ? api.getActive(this.campaignKey) : null;
    if (!active) active = this.activeFromBody();
    if (!active) {
      this.render(null);
      this.stopTicker();
      return;
    }
    this.updateClock(active.remainingMs);
  };

  SmilodoxSecretSalePlp.prototype.startTicker = function () {
    this.stopTicker();
    this.tickerId = window.setInterval(this.tick, 1000);
  };

  SmilodoxSecretSalePlp.prototype.stopTicker = function () {
    if (!this.tickerId) return;
    clearInterval(this.tickerId);
    this.tickerId = null;
  };

  SmilodoxSecretSalePlp.prototype.sync = function () {
    var api = this.api();
    if (api && this.collectionHandle) {
      api.touchLastCollection(this.collectionHandle, this.campaignKey);
    }
    var active = api && api.getActive ? api.getActive(this.campaignKey) : null;
    if (!active) active = this.activeFromBody();
    this.render(active);
    if (active) this.startTicker();
    else this.stopTicker();
  };

  SmilodoxSecretSalePlp.prototype.init = function () {
    var self = this;
    this.sync();
    var api = this.api();
    if (api && api.onChange) {
      this.unsubscribe = api.onChange(function () {
        self.sync();
      });
    }
  };

  SmilodoxSecretSalePlp.prototype.destroy = function () {
    this.destroyed = true;
    this.stopTicker();
    if (typeof this.unsubscribe === "function") this.unsubscribe();
  };

  ready(function () {
    document.querySelectorAll("[data-ssp-root]").forEach(function (root) {
      if (root.__sspInstance) return;
      var instance = new SmilodoxSecretSalePlp(root);
      root.__sspInstance = instance;
      instance.init();
    });
  });

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector("[data-ssp-root]")
      : null;
    if (!root || root.__sspInstance) return;
    var instance = new SmilodoxSecretSalePlp(root);
    root.__sspInstance = instance;
    instance.init();
  });
})();
